import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import {
  AgencySubscriptionDto,
  AgencySubscriptionItemDto,
  FullAgencyDto,
} from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";
import { AssignedOrgsTable } from "@src/features/admin/pages/agencies/components/Tables/AssignedOrgsTable/AssignedOrgsTable";

interface AssignedOrgsContentProps {
  subscription: AgencySubscriptionDto;
  item: AgencySubscriptionItemDto;
  agency: FullAgencyDto;
}

export const AssignedOrgsContent = ({
  item,
  agency,
  subscription,
}: AssignedOrgsContentProps) => {
  const theme = useTheme();
  return (
    <Grid container item direction={"column"}>
      <Grid item>
        <IgTypography variant={"body2"} sx={{ fontWeight: 600 }}>
          Assigned Orgs:
        </IgTypography>
      </Grid>
      {item.stripeProductLinks.length ? (
        <AssignedOrgsTable
          item={item}
          agency={agency}
          subscription={subscription}
        />
      ) : (
        <Grid item textAlign={"center"}>
          <IgTypography
            sx={{ color: theme.palette.text.tonal.error }}
            textAlign={"center"}
            variant={"body2"}
          >
            No organizations assigned to this product
          </IgTypography>
        </Grid>
      )}
    </Grid>
  );
};
